// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mv5Yaj {
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
}

.Dj5bMc {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
}

.E1ncfQ {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

.J_ZtDC {
  width: 1064px;
  height: auto;
  object-fit: contain;
  object-position: center;
}

.N5Nj7G {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-0-5);
}

.ehb3uH {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.K_KBly {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.RE0H0Z {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background: var(--surface-neutral-white);
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  height: fit-content;
}

.JNvZjG {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-dark);
}

/* Responsividade */
@media (max-width: 768px) {
  .mv5Yaj {
    gap: 16px;
  }

  .Dj5bMc {
    margin-bottom: 16px;
  }

  .N5Nj7G {
    gap: var(--spacing-0-25);
  }

  .ehb3uH {
    font-size: 16px;
  }

  .K_KBly {
    font-size: 13px;
  }

  .RE0H0Z {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/HiringPage/components/HiringAddress/HiringAddress.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  height: 100%;\n}\n\n.cardIllustration {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.cardImage {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.emissorCardImage {\n  width: 1064px;\n  height: auto;\n  object-fit: contain;\n  object-position: center;\n}\n\n.explanation {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-0-5);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.summaryCard {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 24px;\n  background: var(--surface-neutral-white);\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  height: fit-content;\n}\n\n.summaryTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n/* Responsividade */\n@media (max-width: 768px) {\n  .stepContent {\n    gap: 16px;\n  }\n\n  .cardIllustration {\n    margin-bottom: 16px;\n  }\n\n  .explanation {\n    gap: var(--spacing-0-25);\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .subtitle {\n    font-size: 13px;\n  }\n\n  .summaryCard {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `mv5Yaj`,
	"cardIllustration": `Dj5bMc`,
	"cardImage": `E1ncfQ`,
	"emissorCardImage": `J_ZtDC`,
	"explanation": `N5Nj7G`,
	"title": `ehb3uH`,
	"subtitle": `K_KBly`,
	"summaryCard": `RE0H0Z`,
	"summaryTitle": `JNvZjG`
};
module.exports = ___CSS_LOADER_EXPORT___;
